import React from 'react';
import PropTypes from "prop-types";

import {styled} from "@mui/material/styles";

import {ReactComponent as Sparkle} from "assets/img/sparkle.svg";
import {greyishBlue300} from "assets/jss/main";

SparkleIcon.propTypes = {
    color: PropTypes.string,
    disabled: PropTypes.bool,
    size: PropTypes.number,
};

const StyledSvg = styled(Sparkle)(({ theme, color, disabled, size}) => ({
    ...size && {
        width: size,
        height: size
    },
    'path': {
        ...color !== null && {
            fill: color
        },
        ...disabled === true &&  {
            fill: greyishBlue300
        }
    },
}));

export default function SparkleIcon(props) {
    return <StyledSvg {...props} />;
}
